import type { Product, ProductCategory } from "../types/content";

export const productCategories: Array<"Todos" | ProductCategory> = [
  "Todos",
  "Pastelaria",
  "Salgados",
  "Refeições",
  "Bebidas",
  "Doces e sobremesas",
  "Encomendas",
];

export const products: Product[] = [
  {
    id: "pasteis",
    name: "Pastel frito",
    category: "Pastelaria",
    description: "Uma das especialidades da casa, preparada para saborear na Casagrande ou levar consigo.",
    image: "PRODUTO_PASTEIS",
    featured: true,
    availabilityNote: "Consulte a seleção do dia",
  },
  {
    id: "coxinhas",
    name: "Coxinhas",
    category: "Salgados",
    description: "Salgados saborosos para uma pausa ou para partilhar em boa companhia.",
    image: "PRODUTO_COXINHAS",
    featured: true,
    availabilityNote: "Favorito dos clientes",
  },
  {
    id: "salgados",
    name: "Variedade de salgados",
    category: "Encomendas",
    description: "Variedades pensadas para festas, reuniões e momentos especiais.",
    image: "PRODUTO_SALGADOS",
    featured: true,
    madeToOrder: true,
    availabilityNote: "Por encomenda",
  },
  {
    id: "feijoada",
    name: "Feijoada",
    category: "Refeições",
    description: "Uma refeição generosa, preparada para quem aprecia sabores reconfortantes.",
    image: "PRODUTO_FEIJOADA",
    featured: true,
    madeToOrder: true,
    availabilityNote: "Disponibilidade sob consulta",
  },
  {
    id: "acai",
    name: "Açaí",
    category: "Doces e sobremesas",
    description: "Uma opção fresca e saborosa, preparada no momento.",
    image: "PRODUTO_ACAI",
    featured: true,
    availabilityNote: "Consulte a disponibilidade",
  },
  {
    id: "caldo-cana",
    name: "Caldo de cana",
    category: "Bebidas",
    description: "Uma das especialidades da casa: uma bebida fresca para acompanhar os nossos sabores.",
    image: "PRODUTO_CALDO_DE_CANA",
    featured: true,
    availabilityNote: "Consulte a disponibilidade",
  },
];
